import { Request } from 'express';
import { ReactElement } from 'react';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { getDehydratedState } from '../../../common/getDehydrateState';
import { t } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import PageLayout from '../../../domain/landing/presentational';
import { ApiErrorBoundary } from '../../../errors/ApiErrorBoundary.class';
import { addError } from '../../../errors/ErrorSlice';
import { thunkSerializeError } from '../../../errors/thunkSerializeError.function';
import { StaticLandingEventLayoutQuery, StaticLandingEventLayoutQueryVariables, StaticLandingEventSection, StaticLandingType } from '../../../graphql/generated/types';
import { CommonMobileHeaderType } from '../../../header/constants';
import { PageViewCustomPropsDataKey } from '../../../logging/PageViewCustomPropsDataKey.enum';
import { setLayout } from '../../../pagewebLayout/PagewebLayoutSlice';
import { nextReduxWrapper } from '../../../state/store';
import { STATIC_LANDING_PAGE_NAME_MAP, STATIC_LANDING_PAGE_SECTION_NAME } from '../../../staticLanding/constants';
import { queryStaticLandingLayout } from '../../../staticLanding/queryStaticLandingLayout';
function StaticLandingEvent({
  layoutId
}: {
  layoutId: string;
}) {
  return <>
      <ApiErrorBoundary>
        <PageLayout id={layoutId} />
      </ApiErrorBoundary>
      <TrackPageViewContainer trackObj={{
      section: STATIC_LANDING_PAGE_SECTION_NAME,
      page: STATIC_LANDING_PAGE_NAME_MAP[StaticLandingType.Event],
      actionType: 'Pageview',
      actionName: '이벤트_화면',
      customProps: {
        user_action: 'pv'
      }
    }} customPropsDataKeyList={[PageViewCustomPropsDataKey.PageCategoryFilter]} />
    </>;
}
StaticLandingEvent.getInitialProps = nextReduxWrapper.getInitialPageProps(store => async context => {
  const cookie = context?.req?.headers.cookie;
  const uidInfoList = context.query?.pathParams as string[];
  try {
    const {
      data,
      queryClient
    } = await queryStaticLandingLayout<StaticLandingEventLayoutQuery, StaticLandingEventLayoutQueryVariables>({
      ssrRequest: context.req as Request,
      type: StaticLandingType.Event,
      cookie,
      uidInfoList
    });
    if (!data || !data.staticLandingEventLayout) {
      throw new Error('이벤트 고정랜딩 레이아웃 데이터가 없습니다.');
    }
    const layoutId = data.staticLandingEventLayout.id;
    // redux에 레이아웃 정보가 없을 때만 setLayout으로 값을 초기화 해줍니다.
    if (!store.getState().pagewebLayout.entities.layouts[layoutId]) {
      store.dispatch(setLayout({
        layout: data.staticLandingEventLayout
      }));
    }
    const staticLandingEventSection = data.staticLandingEventLayout.sections[0] as StaticLandingEventSection;
    return {
      layoutId,
      categoryName: staticLandingEventSection.categoryTabList.find(categoryInfo => categoryInfo.param === String(staticLandingEventSection.param.categoryUid))?.name,
      ...getDehydratedState(queryClient)
    };
  } catch (error) {
    store.dispatch(addError({
      error: thunkSerializeError(error)
    }));
    return {};
  }
});
StaticLandingEvent.getLayout = function getLayout(page: ReactElement) {
  const {
    categoryName
  } = page.props;
  return <Layout title={t('landing_event')} mobileLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true,
    headerType: CommonMobileHeaderType.TwoDepth,
    headerCustomTiaraObject: {
      customProps: {
        page_category_filter: categoryName
      }
    }
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: true
  }}>
      {page}
    </Layout>;
};
export default StaticLandingEvent;